<template>
  <div id="home" />
</template>

<script>
  export default {
    data: () => ({

    }),

    created () {

    },

    methods: {

    },

  }
</script>

<style lang="scss">
.home{
    background-color: white;
    padding-bottom: 16%;
}

.selamat-home{
    margin-top: 10%;
}
.pointerCursor {
    cursor:pointer;
}
</style>
